module.exports = __webpack_public_path__ + "img/l-cb-y1.f24a01b4.gif";